/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AttachmentFilesize } from './attachmentFilesize';
import type { AttachmentUrl } from './attachmentUrl';
import type { AttachmentThumbnailUrl } from './attachmentThumbnailUrl';

/**
 * Uploaded attachment to a submission
 */
export interface Attachment {
  id: string;
  taskId?: string;
  userId?: string;
  filename: string;
  filesize?: AttachmentFilesize;
  url?: AttachmentUrl;
  thumbnailUrl?: AttachmentThumbnailUrl;
  deleted?: boolean;
}
